<template>
  <div id="app" :style="{height:AppHeight,overflow:'auto'}" >
    <div v-if="!$route.meta.keepAlive"  class="header">
      <div style="max-width:920px;margin:auto;">
        <!-- <router-link to="/" style="text-decoration: none; float: left;"> -->
        <el-avatar :size="39" :src="require('@/assets/mtlogo.png')" class="appLogo"></el-avatar>
        <!-- </router-link> -->
        <span class="appTitle">
        销售公司驻外填报助手
        </span>
        <!-- <router-link to="/">主页</router-link>|
        <router-link to="/pageOne">录入1鉴定</router-link>|
        <router-link to="/pageTwo">录入2鉴定</router-link>|
        <router-link to="/ccc">录入3鉴定</router-link>|
        <router-link to="/ddd">录入4鉴定</router-link>| -->
        
        <el-button @click="loginOut" type="text" icon="" name="退出系统" class="layout">&nbsp;退出系统</el-button>
        <el-button @click="ToIndex" type="text" icon="" name="主页" class="layout">主页 &nbsp;|</el-button>
      </div>
    </div>
    <router-view style="max-width:950px;margin:auto;"/>
    <div ref="footer" class="footer">
      技术支持©销售公司综合管理部
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {logout} from '@/api/login.js'
export default {
  name: 'App',
  data(){
    return{
      AppHeight:"1000px",
    }
  },
  created () {
    //在页面加载时读取sessionStorage里的状态信息
    if(sessionStorage.getItem("token") ) {
      //this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
      // console.log(sessionStorage.getItem("token"));
    }

    // //在页面刷新时将vuex里的信息保存到sessionStorage里
    // window.addEventListener("beforeunload",()=>{
    //   sessionStorage.setItem("token",JSON.stringify(this.$store.state))
    //   console.log(JSON.stringify(this.$store.state));
    // })
   
  },
  mounted(){
      // console.log(this.$refs["footer"].offsetTop);
     this.AppHeight =  this.$refs['footer'].offsetTop+'px'
  },
  methods:{
    loginOut:function(){
      this.$confirm("确认退出吗？")
        .then((_) => {
          logout({}).then(response => {
          if(response.data.code == 20000){
            sessionStorage.removeItem("token")
            this.$message({message: "退出成功！",type: "success"});
            Vue.prototype.LoginState = false;
            this.$router.push({ path: "/login" });
          }else{
            this.$alert(response.data.message, "错误信息", { type: "error" })
          }
      })
          done();
        })
        .catch((_) => {});
    
      //  this.$http.post(this.SERVER_URL + "/session/loginOutAction", this.form).then(response => {
      //           if(response.data.code == 20000){
      //             sessionStorage.setItem("token","")
                  
      //             this.$message({message: "退出成功！",type: "success"});
      //             Vue.prototype.LoginState = false;
      //             alert("here!");
      //             this.$router.push({ path: "/login" });
      //           }else{
      //               this.$alert(response.data.message, "错误信息", { type: "error" })
      //           }   
      //           //  if(this.LoginState == false) this.$router.push({ path: "/login" }); //到定向页或者主页  
      //       })
      //       //.catch(response => this.$alert(response.body.message, "错误信息", { type: "error" }));
    },
    ToIndex(){
       this.$router.push({ path: "/" });
    }
  }
}
</script>

<style  type="text/css" scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin: 0px;
  padding: 0px;
  background-color: #2189c0;
}
.header{
  height:30px;
  /* background-color:#ededed; */
  background-color: #2189c0;
  padding: 6px 20px 0px 10px;
  color: white;
  font-weight: bold;
}
.footer {
  height: 30px;
  background-color: rgb(237, 237, 237);
  text-align: center;
  padding-top: 9px;
  position: fixed;
  bottom: 0px;
  width: 100%;
  font-size: 14px;
  z-index: 999;
}
.layout{
  float:right;
  padding-right:0px;
  margin-left:0px;
  color: white;
  position: relative;
  top:-1px;
  right: -5px;
  /* background-color: rgb(0, 182, 182); */
  height: 30px;
  padding: 0px 0px;
}
.appTitle{
  position: relative;
  top:-20px;
}
.appLogo{
  position: relative;
  top:-6px;
}
</style>

<style type="text/css">
.el-dialog {
  border-radius: 12px !important;
}
.el-message-box{
   max-width: 330px !important;
   /* width:300px !important; */
}
.el-message{
  max-width: 330px !important;
}
.el-dialog__body {
  padding: 0px 20px !important;
}
.el-form-item__label{
  font-weight:bold ;
}
</style>



// WEBPACK FOOTER //
// src/App.vue